import React from "react";
import { Paths } from "../../../Paths";
import { Button } from "../common/button/Button";
import { useNavigate } from "react-router-dom";

export function InquiryCompletedPage() {

    const navigate = useNavigate();

    return (
        <div className="inquiry_completed_page">
            <div className="container">
                <h1 className="title">問い合わせを受け付けました</h1>
                <p className="description">
                    問い合わせを受け付けました。追ってモニタリングサービス事務局よりご連絡差し上げます。<br />
                    また、指定したメールアドレス宛に確認のメールを送信しておりますのでご確認ください。
                </p>
                <div className="button_area">
                    <Button label={"トップページに戻る"} onClick={() => navigate(Paths.root)} />
                </div>
            </div>
        </div>

    );
}
